export default __webpack_public_path__ + "static/media/desk.28bb99de.svg";